module.exports = __webpack_public_path__ + "static/media/bg12.e681d3e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/minibg/bg12.jpg
// module id = 594
// module chunks = 0